module.exports = __webpack_public_path__ + "img/tuto_internet_way_02_02.5b7f5e0a.png";